import { DOCTORS_ACTIONS } from 'constants/Actions/Doctors';

// Estado inicial del reducer
const aInitialState = {
    aDoctors: [],
    nTotalPages: 0,
    oDoctor: null,
    nDoctorId: null,
    bIsSuccess: false,
    bIsError: false,

    aDoctorsSuggestion: [],
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a los doctores del sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const DoctorReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case DOCTORS_ACTIONS.GET_ALL:
            return { ...aState, aDoctors: oAction.data.data, nTotalPages: oAction.data.pages };
        case DOCTORS_ACTIONS.GET_ACTIVE:
            return { ...aState, aDoctors: oAction.data.data, nTotalPages: oAction.data.pages };
        case DOCTORS_ACTIONS.FIND:
            return { ...aState, oDoctor: oAction.data };
        case DOCTORS_ACTIONS.ADD:
            return { ...aState, bIsSuccess: true, nDoctorId: oAction.data };
        case DOCTORS_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case DOCTORS_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case DOCTORS_ACTIONS.CLEAN:
            return { ...aState, bIsSuccess: false, bIsError: false, oDoctor: null };
        case DOCTORS_ACTIONS.SUGGESTION:
            return { ...aState, aDoctorsSuggestion: oAction.data };
        case DOCTORS_ACTIONS.SUGGESTION_CLEAN:
            return { ...aState, aDoctorsSuggestion: [] };
        default:
            return aState;
    }
}
